import {EnvironmentModel} from './environment.model';

export const environments: { [hostname: string]: EnvironmentModel } = {
  localhost: {
    production: false,
    version: 'v1',
    authLoginUrl: 'https://api.busy-fly.com/login',
    authLogoutUrl: 'https://api.busy-fly.com/logout',
    authLoginAs: 'https://api.busy-fly.com/autologin-as',
    apiBasepoint: 'https://api.busy-fly.com/api/v1/',
    publicApiBasepoint: 'https://api.busy-fly.com/public-api/v1/',
    supportedLanguages: [
      'ru',
      'uk',
      'en',
      'az',
    ],
    defaultLanguage: 'en',
    documentation: '',
    configUrl: 'https://api.busy-fly.com/public-api/v1/customisation',
    webStompUrl: 'ws://192.168.1.13:15674/ws',
    webStompLogin: 'user',
    webStompPassword: 'user',
    mapTileBaseUrl: 'https://tiles.geliospro.com/hot/',
  },
  'my.busy-fly.com': {
    production: true,
    version: 'v1',
    authLoginUrl: 'https://api.busy-fly.com/login',
    authLogoutUrl: 'https://api.busy-fly.com/logout',
    authLoginAs: 'https://api.busy-fly.com/autologin-as',
    apiBasepoint: 'https://api.busy-fly.com/api/v1/',
    publicApiBasepoint: 'https://api.busy-fly.com/public-api/v1/',
    supportedLanguages: [
      'ru',
      'en',
      'az',
    ],
    defaultLanguage: 'en',
    documentation: 'http://docs.busy-fly.com/',
    configUrl: 'https://api.busy-fly.com/public-api/v1/customisation',
    webStompUrl: 'wss://api.busy-fly.com/ws/',
    webStompLogin: 'browser',
    webStompPassword: 'Guc7tCqBYu689FDt',
    mapTileBaseUrl: 'https://tiles.geliospro.com/hot/',
  },
  'my.geliosrent.ru': {
    production: true,
    version: 'v1',
    authLoginUrl:  'https://api.geliosrent.ru/login',
    authLogoutUrl:  'https://api.geliosrent.ru/logout',
    authLoginAs:  'https://api.geliosrent.ru/autologin-as',
    apiBasepoint: 'https://api.geliosrent.ru/api/v1/',
    publicApiBasepoint: 'https://api.geliosrent.ru/public-api/v1/',
    supportedLanguages: [
      'ru',
      'en',
      'az',
    ],
    defaultLanguage: 'ru',
    documentation: '',
    configUrl: 'https://api.geliosrent.ru/public-api/v1/customisation',
    webStompUrl: 'wss://my.geliosrent.ru/ws/',
    webStompLogin: 'browser',
    webStompPassword: 'Guc7tCqBYu689FDt',
    mapTileBaseUrl: 'https://tile.openstreetmap.org/',
  },
  'admin.kareta.rent': {
    production: true,
    version: 'v1',
    authLoginUrl:  'https://api.kareta.rent/login',
    authLogoutUrl:  'https://api.kareta.rent/logout',
    authLoginAs:  'https://api.kareta.rent/autologin-as',
    apiBasepoint: 'https://api.kareta.rent/api/v1/',
    publicApiBasepoint: 'https://api.kareta.rent/public-api/v1/',
    supportedLanguages: [
      'ru',
      'en',
      'az',
    ],
    defaultLanguage: 'ru',
    documentation: '',
    configUrl: 'https://api.kareta.rent/public-api/v1/customisation',
    webStompUrl: 'wss://admin.kareta.rent/ws/',
    webStompLogin: 'browser',
    webStompPassword: 'Guc7tCqBYu689FDt',
    mapTileBaseUrl: 'https://tile.openstreetmap.org/',
  },
  'my.prokataisya.com.ua': {
    production: true,
    version: 'v1',
    authLoginUrl:  'https://api.prokataisya.com.ua/login',
    authLogoutUrl:  'https://api.prokataisya.com.ua/logout',
    authLoginAs:  'https://api.prokataisya.com.ua/autologin-as',
    apiBasepoint: 'https://api.prokataisya.com.ua/api/v1/',
    publicApiBasepoint: 'https://api.prokataisya.com.ua/public-api/v1/',
    supportedLanguages: [
      'ru',
      'uk',
      'en',
      'az',
    ],
    defaultLanguage: 'uk',
    documentation: '',
    configUrl: 'https://api.prokataisya.com.ua/public-api/v1/customisation',
    webStompUrl: 'wss://api.prokataisya.com.ua/ws/',
    webStompLogin: 'browser',
    webStompPassword: 'Guc7tCqBYu689FDt',
    mapTileBaseUrl: 'https://tile.openstreetmap.org/',
  },
  'adm.salam.az': {
    production: true,
    version: 'v1',
    authLoginUrl: 'https://api.salam.az/login',
    authLogoutUrl: 'https://api.salam.az/logout',
    authLoginAs: 'https://api.salam.az/autologin-as',
    apiBasepoint: 'https://api.salam.az/api/v1/',
    publicApiBasepoint: 'https://api.salam.az/public-api/v1/',
    supportedLanguages: [
      'ru',
      'en',
      'az',
    ],
    defaultLanguage: 'az',
    documentation: '',
    configUrl: 'https://api.salam.az/public-api/v1/customisation',
    webStompUrl: 'wss://adm.salam.az/ws/',
    webStompLogin: 'browser',
    webStompPassword: 'Guc7tCqBYu689FDt',
    mapTileBaseUrl: 'https://tile.openstreetmap.org/',
  },
  'dev.my.busy-fly.com': {
    production: true,
    version: 'v1',
    authLoginUrl:  'https://dev.api.busy-fly.com/login',
    authLogoutUrl:  'https://dev.api.busy-fly.com/logout',
    authLoginAs:  'https://dev.api.busy-fly.com/autologin-as',
    apiBasepoint: 'https://dev.api.busy-fly.com/api/v1/',
    publicApiBasepoint: 'https://dev.api.busy-fly.com/public-api/v1/',
    supportedLanguages: [
      'ru',
      'en',
      'az',
    ],
    defaultLanguage: 'en',
    documentation: 'http://docs.busy-fly.com/',
    configUrl: 'https://api.busy-fly.com/public-api/v1/customisation',
    webStompUrl: 'wss://api.busy-fly.com/ws/',
    webStompLogin: 'browser',
    webStompPassword: 'Guc7tCqBYu689FDt',
    mapTileBaseUrl: 'https://tiles.geliospro.com/hot/',
  },
  'item-sharing-web-admin.geliossoft.ru': {
    production: false,
    version: 'v1',
    authLoginUrl: 'https://item-sharing-web-backend.geliossoft.ru/login',
    authLogoutUrl: 'https://item-sharing-web-backend.geliossoft.ru/logout',
    authLoginAs: 'https://item-sharing-web-backend.geliossoft.ru/autologin-as',
    apiBasepoint: 'https://item-sharing-web-backend.geliossoft.ru/api/v1/',
    publicApiBasepoint: 'https://item-sharing-web-backend.geliossoft.ru/public-api/v1/',
    supportedLanguages: [
      'ru',
      'uk',
      'en',
      'az',
    ],
    documentation: '',
    defaultLanguage: 'en',
    configUrl: 'https://item-sharing-web-backend.geliossoft.ru/public-api/v1/customisation',
    webStompUrl: 'wss://192.168.1.13:15674/ws',
    webStompLogin: 'user',
    webStompPassword: 'user',
    mapTileBaseUrl: 'https://tiles.geliospro.com/hot/',
  },
  'item-sharing-web-admin-2.sks': {
    production: false,
    version: 'v1',
    authLoginUrl:  'http://item-sharing-web-backend-2.sks/login',
    authLogoutUrl:  'http://item-sharing-web-backend-2.sks/logout',
    authLoginAs:  'http://item-sharing-web-backend-2.sks/autologin-as',
    apiBasepoint: 'http://item-sharing-web-backend-2.sks/api/v1/',
    publicApiBasepoint: 'http://item-sharing-web-backend-2.sks/public-api/v1/',
    supportedLanguages: [
      'ru',
      'uk',
      'en',
      'az',
    ],
    defaultLanguage: 'en',
    documentation: '',
    configUrl: 'http://item-sharing-web-backend-2.sks/public-api/v1/customisation',
    webStompUrl: 'ws://192.168.1.13:15674/ws',
    webStompLogin: 'user',
    webStompPassword: 'user',
    mapTileBaseUrl: 'https://tiles.geliospro.com/hot/',
  },
  'item-sharing-web-admin-3.sks': {
    production: false,
    version: 'v1',
    authLoginUrl:  'http://item-sharing-web-backend-3.sks/login',
    authLogoutUrl:  'http://item-sharing-web-backend-3.sks/logout',
    authLoginAs:  'http://item-sharing-web-backend-3.sks/autologin-as',
    apiBasepoint: 'http://item-sharing-web-backend-3.sks/api/v1/',
    publicApiBasepoint: 'http://item-sharing-web-backend-3.sks/public-api/v1/',
    supportedLanguages: [
      'ru',
      'uk',
      'en',
      'az',
    ],
    defaultLanguage: 'en',
    documentation: '',
    configUrl: 'http://item-sharing-web-backend-3.sks/public-api/v1/customisation',
    webStompUrl: 'ws://192.168.1.13:15674/ws',
    webStompLogin: 'user',
    webStompPassword: 'user',
    mapTileBaseUrl: 'https://tiles.geliospro.com/hot/',
  },
  'item-sharing-web-admin-4.sks': {
    production: false,
    version: 'v1',
    authLoginUrl:  'http://item-sharing-web-backend-4.sks/login',
    authLogoutUrl:  'http://item-sharing-web-backend-4.sks/logout',
    authLoginAs:  'http://item-sharing-web-backend-4.sks/autologin-as',
    apiBasepoint: 'http://item-sharing-web-backend-4.sks/api/v1/',
    publicApiBasepoint: 'http://item-sharing-web-backend-4.sks/public-api/v1/',
    supportedLanguages: [
      'ru',
      'uk',
      'en',
      'az',
    ],
    defaultLanguage: 'en',
    documentation: '',
    configUrl: 'http://item-sharing-web-backend-4.sks/public-api/v1/customisation',
    webStompUrl: 'ws://192.168.1.13:15674/ws',
    webStompLogin: 'user',
    webStompPassword: 'user',
    mapTileBaseUrl: 'https://tiles.geliospro.com/hot/',
  },
  'item-sharing-web-admin-5.sks': {
    production: false,
    version: 'v1',
    authLoginUrl:  'http://item-sharing-web-backend-5.sks/login',
    authLogoutUrl:  'http://item-sharing-web-backend-5.sks/logout',
    authLoginAs:  'http://item-sharing-web-backend-5.sks/autologin-as',
    apiBasepoint: 'http://item-sharing-web-backend-5.sks/api/v1/',
    publicApiBasepoint: 'http://item-sharing-web-backend-5.sks/public-api/v1/',
    supportedLanguages: [
      'ru',
      'uk',
      'en',
      'az',
    ],
    defaultLanguage: 'en',
    documentation: '',
    configUrl: 'http://item-sharing-web-backend-5.sks/public-api/v1/customisation',
    webStompUrl: 'ws://192.168.1.13:15674/ws',
    webStompLogin: 'user',
    webStompPassword: 'user',
    mapTileBaseUrl: 'https://tiles.geliospro.com/hot/',
  },
  'item-sharing-web-admin-for-vlad.sks': {
    production: false,
    version: 'v1',
    authLoginUrl:  'http://item-sharing-web-backend-for-vlad.sks/login',
    authLogoutUrl:  'http://item-sharing-web-backend-for-vlad.sks/logout',
    authLoginAs:  'http://item-sharing-web-backend-for-vlad.sks/autologin-as',
    apiBasepoint: 'http://item-sharing-web-backend-for-vlad.sks/api/v1/',
    publicApiBasepoint: 'http://item-sharing-web-backend-for-vlad.sks/public-api/v1/',
    supportedLanguages: [
      'ru',
      'uk',
      'en',
      'az',
    ],
    documentation: '',
    defaultLanguage: 'en',
    configUrl: 'http://item-sharing-web-backend-for-vlad.sks/public-api/v1/customisation',
    webStompUrl: 'wss://192.168.1.13:15674/ws',
    webStompLogin: 'user',
    webStompPassword: 'user',
    mapTileBaseUrl: 'https://tiles.geliospro.com/hot/',
  },
  'item-sharing-web-admin-for-valera.sks': {
    production: false,
    version: 'v1',
    authLoginUrl:  'http://item-sharing-web-backend-for-valera.sks/login',
    authLogoutUrl:  'http://item-sharing-web-backend-for-valera.sks/logout',
    authLoginAs:  'http://item-sharing-web-backend-for-valera.sks/autologin-as',
    apiBasepoint: 'http://item-sharing-web-backend-for-valera.sks/api/v1/',
    publicApiBasepoint: 'http://item-sharing-web-backend-for-valera.sks/public-api/v1/',
    supportedLanguages: [
      'ru',
      'uk',
      'en',
      'az',
    ],
    documentation: '',
    defaultLanguage: 'en',
    configUrl: 'http://item-sharing-web-backend-for-valera.sks/public-api/v1/customisation',
    webStompUrl: 'wss://192.168.1.13:15674/ws',
    webStompLogin: 'user',
    webStompPassword: 'user',
    mapTileBaseUrl: 'https://tiles.geliospro.com/hot/',
  },
};
